<section class="section-md" *ngIf="productId">
  <h3>{{ 'BOARDING.TITLE' | translate }}</h3>
  <p class="desc" *ngIf="!form">{{ 'BOARDING.DESC' | translate }}</p>
  <p role="status" *ngIf="message">{{ message | translate }}</p>
  <p role="alert" *ngIf="serverMessage">{{ serverMessage }}</p>
  <fieldset [disabled]="loading || saving || !revision">
    <ng-container *ngIf="form; else editor">
      <ng-container *ngIf="selected != null; else legacy">
        <p>{{ 'BOARDING.SELECT_DESC' | translate }}</p>
        <label *ngFor="let location of locations" class="d-flex align-items-center gap-2 py-2">
          <input
            type="checkbox"
            [checked]="selected.includes(location.id)"
            [disabled]="!location.active && !selected.includes(location.id)"
            (change)="toggle(location.id, $any($event.target).checked)"
          />
          {{ location.name.ko }} <span *ngIf="!location.active">({{ 'BOARDING.INACTIVE' | translate }})</span>
        </label>
      </ng-container>
      <ng-template #legacy>
        <button
          type="button"
          class="nnb-btn-md nnb-btn-secondary"
          *ngIf="locations.length"
          [disabled]="!canConvert"
          (click)="convert()"
        >
          {{ 'BOARDING.CONVERT' | translate }}
        </button>
        <p class="desc" *ngIf="locations.length && !canConvert">{{ 'BOARDING.MATCH_REQUIRED' | translate }}</p>
      </ng-template>
    </ng-container>
    <ng-template #editor>
      <div *ngFor="let row of locations; let index = index" class="border rounded p-3 mb-3">
        <label class="d-block" *ngFor="let language of ['ko', 'en', 'ja', 'zh-Hant']">
          {{ 'BOARDING.' + language | translate }}
          <input
            class="form-control mb-2"
            [ngModel]="row.name[language]"
            (ngModelChange)="row.name[language] = $event; dirty = true"
            [ngModelOptions]="{ standalone: true }"
            maxlength="100"
            [attr.aria-label]="('BOARDING.TITLE' | translate) + ' ' + (index + 1) + ' ' + language"
            [readOnly]="language === 'ko' && persistedIds.has(row.id)"
          />
        </label>
        <button type="button" class="nnb-btn-sm" *ngIf="!persistedIds.has(row.id)" (click)="remove(row.id)">
          {{ 'BOARDING.REMOVE' | translate }}
        </button>
        <label class="d-flex align-items-center gap-2 py-2"
          ><input
            type="checkbox"
            [(ngModel)]="row.active"
            (ngModelChange)="dirty = true"
            [ngModelOptions]="{ standalone: true }"
          />{{ 'BOARDING.ACTIVE' | translate }}</label
        >
      </div>
      <button type="button" class="nnb-btn-md nnb-btn-secondary" [disabled]="locations.length >= 30" (click)="add()">
        {{ 'BOARDING.ADD' | translate }}
      </button>
      <button type="button" class="nnb-btn-md nnb-btn-primary" [disabled]="!dirty" (click)="save()">
        {{ 'BOARDING.SAVE' | translate }}
      </button>
    </ng-template>
  </fieldset>
</section>
